<template>
  <div class="min-h-screen bg-gray-100 pb-20">
    <div class="max-w-[600px] mx-auto">
      
      <!-- Header -->
      <div class="bg-white sticky top-0 z-10 shadow-sm">
        <div class="flex items-center gap-3 p-4">
          <button @click="$router.back()" class="p-1">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h1 class="text-lg font-bold text-gray-800 flex-1">{{ isEdit ? 'İlan Düzenle' : 'Yeni İlan Ver' }}</h1>
          <button @click="saveListing" class="text-takas-sari font-semibold">Kaydet</button>
        </div>
      </div>

      <div class="p-4 space-y-4">
        
        <!-- Fotoğraf Ekle -->
        <div class="bg-white rounded-xl p-4">
          <label class="block text-sm font-semibold text-gray-800 mb-2">Fotoğraflar</label>
          <div class="flex gap-2 overflow-x-auto pb-2">
            <div v-for="(img, index) in listing.images" :key="index" class="relative flex-shrink-0">
              <div class="w-24 h-24 bg-gradient-to-br from-takas-sari/30 to-yellow-400/30 rounded-xl flex items-center justify-center">
                <span class="text-3xl">{{ img.icon || '📷' }}</span>
              </div>
              <button @click="removeImage(index)" class="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs">✕</button>
            </div>
            <button @click="addImage" class="w-24 h-24 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center gap-1 flex-shrink-0">
              <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
              </svg>
              <span class="text-xs text-gray-500">Ekle</span>
            </button>
          </div>
          <p class="text-xs text-gray-400 mt-2">En fazla 5 fotoğraf ekleyebilirsiniz</p>
        </div>

        <!-- Başlık -->
        <div class="bg-white rounded-xl p-4">
          <label class="block text-sm font-semibold text-gray-800 mb-2">İlan Başlığı *</label>
          <input 
            v-model="listing.title" 
            type="text" 
            class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
            placeholder="Örn: iPhone 14 Pro"
          />
        </div>

        <!-- Kategori -->
        <div class="bg-white rounded-xl p-4">
          <label class="block text-sm font-semibold text-gray-800 mb-2">Kategori *</label>
          <select v-model="listing.category" class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari">
            <option value="">Kategori seçin</option>
            <option v-for="cat in categories" :key="cat.name" :value="cat.name">{{ cat.name }}</option>
          </select>
        </div>

        <!-- Açıklama -->
        <div class="bg-white rounded-xl p-4">
          <label class="block text-sm font-semibold text-gray-800 mb-2">Açıklama *</label>
          <textarea 
            v-model="listing.description" 
            rows="5" 
            class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
            placeholder="Ürününüz hakkında detaylı bilgi verin..."></textarea>
        </div>

        <!-- Takas İstediği -->
        <div class="bg-white rounded-xl p-4">
          <label class="block text-sm font-semibold text-gray-800 mb-2">Takas İstediği *</label>
          <input 
            v-model="listing.wantsToTrade" 
            type="text" 
            class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
            placeholder="Örn: iPhone 15, Samsung S23 veya nakit"
          />
        </div>

        <!-- Durum ve Konum -->
        <div class="grid grid-cols-2 gap-3">
          <div class="bg-white rounded-xl p-4">
            <label class="block text-sm font-semibold text-gray-800 mb-2">Durum</label>
            <select v-model="listing.condition" class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari">
              <option value="Yeni">Yeni</option>
              <option value="Yeni gibi">Yeni gibi</option>
              <option value="İyi">İyi</option>
              <option value="Orta">Orta</option>
            </select>
          </div>
          <div class="bg-white rounded-xl p-4">
            <label class="block text-sm font-semibold text-gray-800 mb-2">Konum</label>
            <input 
              v-model="listing.location" 
              type="text" 
              class="w-full p-3 border border-gray-200 rounded-xl focus:outline-none focus:border-takas-sari"
              placeholder="İstanbul, Ankara..."
            />
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddListing',
  data() {
    return {
      isEdit: false,
      listingId: null,
      listing: {
        title: '',
        category: '',
        description: '',
        wantsToTrade: '',
        condition: 'Yeni',
        location: '',
        images: [{ icon: '📱' }]
      },
      categories: [
        { name: 'Antika' }, { name: 'Anne & Bebek' }, { name: 'Beyaz Esya' },
        { name: 'Bilgisayar' }, { name: 'Tablet' }, { name: 'Telefon' },
        { name: 'Diger Elektronik' }, { name: 'Ev & Bahce' }, { name: 'Giyim' },
        { name: 'Hizmet' }, { name: 'Kitap & Dergi' }, { name: 'Kirtasiye' },
        { name: 'Kisisel Bakim' }, { name: 'Koleksiyon' }, { name: 'Mobilya' },
        { name: 'Muzik Aletleri' }, { name: 'Oto Aksesuar' }, { name: 'Oyun & Konsol' },
        { name: 'Outdoor & Kamp' }, { name: 'Sanat & El Isi' }, { name: 'Spor' },
        { name: 'Telefon Aksesuar' }
      ]
    }
  },
  created() {
    if (this.$route.params.id) {
      this.isEdit = true
      this.listingId = this.$route.params.id
      this.loadListingData()
    }
  },
  methods: {
    loadListingData() {
      this.listing = {
        title: 'iPhone 14 Pro',
        category: 'Telefon',
        description: 'Kutusu ve aksesuarlarıyla birlikte...',
        wantsToTrade: 'iPhone 15',
        condition: 'Yeni gibi',
        location: 'İstanbul',
        images: [{ icon: '📱' }, { icon: '📱' }]
      }
    },
    addImage() {
      if (this.listing.images.length < 5) {
        this.listing.images.push({ icon: '📷' })
      }
    },
    removeImage(index) {
      this.listing.images.splice(index, 1)
    },
    saveListing() {
      if (!this.listing.title || !this.listing.category || !this.listing.description) {
        alert('Lütfen tüm zorunlu alanları doldurun')
        return
      }
      console.log('İlan kaydedildi:', this.listing)
      alert(this.isEdit ? 'İlan güncellendi!' : 'İlanınız yayınlandı!')
      this.$router.back()
    }
  }
}
</script>